module.exports = __webpack_public_path__ + "media/images/noaa_logo_74x74-579e5525fb247fdc7d7ce284e1cdf18d.png";